import { useEffect, useState } from "react";
import "../../screen/nuove-sezioni/fonts.scss";
import styles from "./Header.module.scss";

import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// voci del menu: stesso ordine delle sezioni della home
const voci = [
  { testo: "Chi sono", id: "chi-sono" },
  { testo: "Servizi", id: "servizi" },
  { testo: "Lavori", id: "lavori" },
];

const cta = { testo: "Lavoriamo insieme", id: "contatti" };

const Header = () => {
  const [onChange, setOnChange] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [attiva, setAttiva] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);

      // la voce attiva è l'ultima sezione il cui inizio ha superato metà schermo
      let corrente = "";
      voci.forEach(({ id }) => {
        const sezione = document.getElementById(id);
        if (sezione && sezione.getBoundingClientRect().top <= window.innerHeight / 2) {
          corrente = id;
        }
      });
      setAttiva(corrente);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const Menu = () => {
    setOnChange(!onChange);
  };

  const chiudi = () => setOnChange(false);

  return (
    <div className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}>
      <div className={styles["header__inner"]}>
        <a className={styles["header__name"]} href="#chi-sono" onClick={chiudi}>
          agnese<span className={styles["header__dot"]}>.</span>morlin
        </a>

        <nav className={styles["header__nav"]}>
          {voci.map(({ testo, id }) => (
            <a
              key={id}
              className={`${styles["header__link"]} ${attiva === id ? styles["header__link--attivo"] : ""}`}
              href={`#${id}`}
            >
              {testo}
            </a>
          ))}
          <a className={styles["header__cta"]} href={`#${cta.id}`}>
            {cta.testo}
          </a>
        </nav>

        <FontAwesomeIcon
          className={styles["header__icon"]}
          onClick={Menu}
          icon={onChange ? faXmark : faBars}
        />
      </div>

      <div className={`${styles["header__container-mobile"]} ${onChange ? styles.open : ""}`}>
        {voci.map(({ testo, id }) => (
          <a key={id} className={styles["header__link-mobile"]} href={`#${id}`} onClick={chiudi}>
            {testo}
          </a>
        ))}
        <a
          className={`${styles["header__link-mobile"]} ${styles["header__link-mobile--cta"]}`}
          href={`#${cta.id}`}
          onClick={chiudi}
        >
          {cta.testo}
        </a>
      </div>
    </div>
  );
};

export default Header;
